"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.NestedRows = void 0;
var _nestedRows = require("./nestedRows");
exports.PLUGIN_KEY = _nestedRows.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _nestedRows.PLUGIN_PRIORITY;
exports.NestedRows = _nestedRows.NestedRows;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/nestedRows/index.js
// module id = 1529
// module chunks = 0